import { FC, ReactNode, useMemo } from 'react'
import { useRouter } from 'next/router'
import { Configure, InstantSearch } from 'react-instantsearch'

import { typesenseInstantSearchAdapter } from '../../utils/typesense/config'
import { getCountryAndLocaleStrings } from '../../utils/locales'

interface ProductSearchProviderProps {
  children: ReactNode
}

const ProductSearchProvider: FC<ProductSearchProviderProps> = ({ children }) => {
  const { locale: countryAndLangString } = useRouter()
  const { country, locale } = getCountryAndLocaleStrings(countryAndLangString)

  // Memoize to prevent object recreation on every render
  const facetRefinements = useMemo(() => ({
    'country-availability': [country.toUpperCase()],
  }), [country])

  const disjunctiveFacets = useMemo(() => [
    `categories.one.${locale}`,
    `categories.two.${locale}`,
    `categories.three.${locale}`,
  ], [locale])

  return (
    <InstantSearch
      indexName="products"
      searchClient={typesenseInstantSearchAdapter.searchClient}
      future={{
        preserveSharedStateOnUnmount: true,
      }}
    >
      <Configure
        disjunctiveFacets={disjunctiveFacets}
        facetsRefinements={facetRefinements}
      />
      {children}
    </InstantSearch>
  )
}

export default ProductSearchProvider
